<template>
    <v-card elevation="1">
        <v-card-title>Qualification</v-card-title>

        <v-alert
            v-if="!meet.jo_qualification_meet && !meet.elite_qualification_meet"
            border="left"
            class="mx-4"
            colored-border
            type="info"
        >
            This meet is not a qualification meet. The scores shown are simply for informational purposes.
        </v-alert>

        <v-tabs v-if="qualifications.length > 1" v-model="qualificationTab">
            <v-tab v-for="qualification in qualifications" :key="qualification.id">
                {{ qualification.level_to }}
            </v-tab>
        </v-tabs>

        <v-tabs-items v-if="qualifications.length > 1" v-model="qualificationTab">
            <v-tab-item v-for="qualification in qualifications" :key="qualification.id">
                <qualification-table :qualification="qualification" />
            </v-tab-item>
        </v-tabs-items>

        <div v-else>
            <qualification-table
                v-for="qualification in qualifications"
                :key="qualification.id"
                :qualification="qualification"
            />
        </div>
    </v-card>
</template>

<script>
import QualificationTable from '@/Components/QualificationTable.vue';
import Meet from '@/Models/Meet.js';

export default {
    name: 'QualificationDisplay',

    components: { QualificationTable },

    props: {
        value: {
            type: Boolean,
            required: false,
            default: false,
        },

        qualifications: {
            type: Array,
            required: true,
        },

        meet: {
            type: Meet,
            required: true,
        },
    },

    data: () => ({
        qualificationTab: 0,
    }),

    computed: {},

    methods: {},
};
</script>
